import React from 'react';
import styled from 'styled-components';

import Switch from '../../../../components/common/Switch';
import { SwitchIconImg } from '../../../../styled-components/shared';
import { GenericMissionIcon } from '../../assets/img';

const Wrap = styled.div`
  display: flex;
  align-items: center;

  .switch-label {
    white-space: nowrap;
  }
`;

const MissionBasketIconComponent = (props: typeof styled.img) => <SwitchIconImg {...props} src={GenericMissionIcon} />;

type Props = {
  className?: string;
  toggled: boolean;
  disabled: boolean;
  label: string;
};

const MissionBasketSwitch = ({ className, toggled = false, label = 'Mission', disabled }: Props) => {
  return (
    <Wrap className={className}>
      <Switch PrimaryIcon={MissionBasketIconComponent} toggled={toggled} label={label} disabled={disabled} passive />
    </Wrap>
  );
};

export default MissionBasketSwitch;
